module.exports = __webpack_public_path__ + "img/NG-logo.4b674e73.jpg";